import {
    GETUSERNAMECONTACTSUGGESTION_SUCCESS,
    GETUSERNAMECONTACTSUGGESTION_FAILED,
    RESET_GETUSERNAMECONTACTSUGGESTION,
    LOADING_GETUSERNAMECONTACTSUGGESTION,
    NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTION
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetUsernameContactSuggestion = () => {
    return { type: RESET_GETUSERNAMECONTACTSUGGESTION };
};

const getUserNameContactSuggestionList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETUSERNAMECONTACTSUGGESTION });
    await partnerServices
        .post("getUsernameContactSuggestion", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(GETUSERNAMECONTACTSUGGESTIONsuccess(res.data));
                    break;
                default:
                    dispatch(GETUSERNAMECONTACTSUGGESTIONFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTION,
                payload: err
            });
        });
};
function GETUSERNAMECONTACTSUGGESTIONsuccess(data) {
    return {
        type: GETUSERNAMECONTACTSUGGESTION_SUCCESS,
        payload: data
    };
}
function GETUSERNAMECONTACTSUGGESTIONFailed(data) {
    return {
        type: GETUSERNAMECONTACTSUGGESTION_FAILED,
        payload: data
    };
}

export { resetGetUsernameContactSuggestion, getUserNameContactSuggestionList };
